import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import {
  getIdentityActivitiesHistorySliced,
  getIdentityActivitiesHistoryItems,
  getCurrentProTrackProgressDay,
  isFirstActionFinished,
  isStageIsSelection,
} from 'store/entities/identity/selectors'

import { getActivitiesColors } from 'helpers/getColorsInfoForActivities'

import ActivityColorPanel from './ActivityColorPanel'

const mapStateToProps = state => {
  const activities = getIdentityActivitiesHistorySliced(state)
  const userActivities = getIdentityActivitiesHistoryItems(state)
  const currentDay = getCurrentProTrackProgressDay(state)
  const activitiesSize = activities.size

  return {
    actionsColorsInfo: getActivitiesColors(userActivities, currentDay),
    currentDay: getCurrentProTrackProgressDay(state),
    showStats: !isStageIsSelection(state) && !!activitiesSize && isFirstActionFinished(state),
  }
}

export default connect(mapStateToProps)(withTranslation('user')(ActivityColorPanel))
